<template>
    <form>
        <div class="dashboard-block">
            <h2>Profile Visibility</h2>

                <div class="panel panel-grey">
                    <div class="panel-body">
                        <div class="row row-clear-md-4">
                            <div class="col-xs-12 col-md-4">
                                <div class="form-group">
                                    <label class="control-label">Featured Until</label>
                                    <div class="input-group">
                                        <flat-pickr
                                                v-model="stateDateFeaturedUntil"
                                                :config="flatPickrConfig"
                                                class="form-control"
                                                placeholder="DD/MM/YYYY"
                                                name="featured_until">
                                        </flat-pickr>

                                        <span class="input-group-addon" data-toggle>
                              <i class="fa fa-calendar"></i>
                            </span>

                                        <span class="input-group-addon" data-clear>
                              <i class="fa fa-times"></i>
                            </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-12 col-md-4">
                                <div class="form-group">

                                    <div class="row">
                                        <br>
                                        <div class="col-xs-4 col-sm-4">
                                            <div class="radio radio-primary">
                                                <input
                                                        type="radio"
                                                        name="profile_visibility"
                                                        id="profile_visibility_public"
                                                        value="public"
                                                        v-model="$v.stateVisibility.$model">
                                                <label for="profile_visibility_public">
                                                    Public
                                                </label>
                                            </div>
                                        </div>

                                        <div class="col-xs-4 col-sm-4">
                                            <div class="radio radio-primary">
                                                <input
                                                        type="radio"
                                                        name="profile_visibility"
                                                        id="profile_visibility_hidden"
                                                        value="hidden"
                                                        v-model="$v.stateVisibility.$model">
                                                <label for="profile_visibility_hidden">
                                                    Hidden
                                                </label>
                                            </div>
                                        </div>

                                        <div class="col-xs-4 col-sm-4">
                                          <div class="radio radio-primary">
                                            <input
                                              type="radio"
                                              name="profile_visibility"
                                              id="profile_visibility_private"
                                              value="private"
                                              v-model="$v.stateVisibility.$model">
                                            <label for="profile_visibility_private">
                                              Private
                                            </label>
                                          </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="panel-footer">
                        <ladda-button
                                type="submit"
                                class="btn btn-sm btn-primary"
                                :click="handleSaveChangesCallback">
                            Save Changes
                        </ladda-button>
                    </div>
                </div>
        </div>
    </form>
</template>

<script>
import { stateMapper } from 'mixins/users'
import { mapActions } from 'vuex'
import { notify } from 'utils'
import FlatPickr from 'vue-flatpickr-component'
import Selectize from '../ext/codium/CodiumSelectize'
import { required } from 'vuelidate/lib/validators'

export default {
  mixins: [stateMapper],

  validations: {
    stateVisibility: { required }
  },

  data () {
    return {
      flatPickrConfig: {
        altInput: true,
        altFormat: 'd/m/Y',
        dateFormat: 'Y-m-d 00:00:00',
        wrap: true
      }
    }
  },

  components: {
    FlatPickr,
    Selectize
  },

  methods: {
    ...mapActions('user', ['updateUser']),

    handleSaveChangesCallback () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        notify.error('Some fields are invalid. Please check and try again.')
        return Promise.resolve()
      }
      return this.updateUser({
        id: this.user.id,
        payload: {
          profile: {
            date_featured_until: this.user.profile.date_featured_until,
            visibility: this.user.profile.visibility,
            notification_preference: this.user.profile.notification_preference
          }
        }
      }).then(() => {
        notify.success('Successfully saved talent visibility details.')
      }).catch((error) => {
        if (error.response && error.response.status === 422) {
          notify.error('There was a problem updating talent visibility details. Please try again.')
        } else {
          throw error
        }
      })
    }
  }
}
</script>
